<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import McButton from '@/components/McButton'
import McEmptyState from '@/components/McEmptyState'
import { Helper } from '@/mixin/helper'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
import { mapGetters } from 'vuex'
import {
  CREATE_ADDRESS,
  GET_DETAIL_ADDRESS,
  UPDATE_ADDRESS,
  GET_ADDRESS,
  GET_PROVINCES,
  GET_CITIES,
  GET_DISTRICTS,
  GET_REGION_BY_LAT_LNG,
} from '@/services/api/master/address'
import { GET_ORTHOPHOTOS } from '@/services/api/master/orthophoto'
import { GET_ADDRESS_CATEGORIES } from '@/services/api/setting/general/address'
import * as customerApi from '@/services/rest-api/lib/customer/customer'
import FreeWhatsappAlert from './lib/components/FreeWhatsappAlert'

import { GetAddressData } from '@/services/api/map'
import { MixPanel } from '@/mixin/mixpanel'
import { debounce } from '@/helpers/debounce'

import { getAddress, getGeolocation } from '@/services/api/geolocation'
import { getPlaceDetail } from '@/services/api/google/placeDetail'
import { getPlacesAutocomplete } from '@/services/api/google/autocomplete'

import LoadingSkeleton from './LoadingSkeleton.vue'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Address',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    FreeWhatsappAlert,
    McEmptyState,
    LoadingSkeleton,
  },
  mixins: [MixPanel, Helper],
  apollo: {
    orthophotos: {
      query: GET_ORTHOPHOTOS,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            status: ['Ready'],
          },
        }
      },
      skip() {
        return !this.hasAccess('j1a-orthophoto-map-lv2:read')
      },
      result({ data, loading }) {
        if (!loading) {
          const rows = data?.orthophotos?.orthophotos?.data || []
          const ids = rows.map((r) => r?.orthophotoId).filter((v) => v != null)
          const bList = rows
            .map((r) => r?.bounds)
            .filter((b) => Array.isArray(b) && b.length === 4)
            .map(([west, north, east, south]) => ({
              minX: west,
              minY: south,
              maxX: east,
              maxY: north,
            }))
          let union = null
          bList.forEach((b) => {
            if (!union) {
              union = { ...b }
            } else {
              union.minX = Math.min(union.minX, b.minX)
              union.minY = Math.min(union.minY, b.minY)
              union.maxX = Math.max(union.maxX, b.maxX)
              union.maxY = Math.max(union.maxY, b.maxY)
            }
          })
          this.$store.dispatch('orthophoto/setOrthophotos', {
            ids,
            bounds: union,
            autoZoom: false,
            isLoaded: true,
            token: data?.orthophotos?.orthophotos?.token,
          })
          this.refreshOrthophotoLayer()
        }
      },
    },
    geofence: {
      query: GET_DETAIL_ADDRESS,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            geofenceId: parseInt(this.id),
          },
        }
      },
      // Disable the query
      skip() {
        return this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          this.loading = true
          if (data.geofence.geofence.contacts.length > 0) {
            data.geofence.geofence.contacts = data.geofence.geofence.contacts.map((c) => ({
              name: c.name,
              phoneNo: c.phoneNo,
              sendWhatsapp: c.sendWhatsapp,
            }))
          } else {
            data.geofence.geofence.contacts = [
              {
                name: '',
                phoneNo: '',
                sendWhatsapp: !this.isGeofenceContactFormFlagActive,
              },
            ]
          }
          this.geofence.geofence = data.geofence.geofence
          this.geofence.geofence.serviceDuration = this.convertHHMMSSIntervalToIso8601(
            data.geofence.geofence.serviceDuration
          )
          this.userLogging('Access', this.$route, this.geofence.geofence.fenceName)
          setTimeout(() => {
            this.initEditPage()
            this.loading = false
          }, 800)
        }
      },
    },
    geofences: {
      query: GET_ADDRESS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          const geofences = data.geofences.geofences.data
          this.isHQ = geofences.some((geofence) => geofence.category === 'Kantor Pusat')
        }
      },
    },
    addressCategories: {
      query: GET_ADDRESS_CATEGORIES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            isHaveRitageScope: this.hasAccessAll([
              'j2a-ritage-master-data:read',
              'j2a-ritage-master-data:create',
            ]),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.categoryOptions = data.addressCategories.addressCategories.map((item) => item.text)

          const defaultCategory = data.addressCategories.addressCategories.find(
            (item) => item.text === 'Umum'
          )
          if (defaultCategory) {
            this.form.sector = defaultCategory.text

            this.fullObject.sector = {
              key: defaultCategory.text,
              label: defaultCategory.text,
            }
          }
        }
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'check',
        },
        {
          key: 'type',
          label: 'Type',
          tdClass: 'typeWidth',
        },
        {
          key: 'number',
          label: 'Number',
        },
        {
          key: 'expired',
          label: 'Expired',
        },
        {
          key: 'status',
          label: 'Status',
        },
      ],
      addressCategories: {
        addressCategories: [],
      },
      categoryOptions: [],
      isEdit: false,
      isInitSearchRegion: false,
      form: {
        customer: null,
        sector: null,
        location_name: null,
        address: null,
        province: null,
        city: null,
        district: null,
        postal_code: null,
        contact_person: null,
        phone_no: null,
        radius: 100,
        latitude: '',
        longitude: '',
        serviceStart: null,
        serviceEnd: null,
        circle_data: [],
        poly_data: [],
        address_detail: '',
        latLang: '',
        is_garage: false,
        is_service: false,
        is_billingAddr: false,
        is_depot: true,
        service_location: '',
        send_whatsapp: true,
        contacts: [
          {
            name: '',
            phoneNo: '',
            sendWhatsapp: false,
          },
        ],
        operationalDay: ['0'],
        serviceDuration: null,
        reference_id: null,
      },
      geofence: {
        geofence: {},
      },
      isSubmit: false,
      loading: true,
      poly_error: false,
      circle_error: false,
      searchLocation: null,
      map_radio: 'circle',
      map: null,
      circle: null,
      polygon: null,
      places: [],
      id: this.$route.params.id || 0,
      page: 1,
      invalid: false,
      duplicateLocation: false,
      duplicateReferenceId: false,
      state: localStorage.getItem('stateAddress'),
      isHQ: false,
      hideForm: true,
      fullObject: {
        sector: {},
        province: {},
        city: {},
        district: {},
        customer: {},
      },
      isFirstInitialization: true,
      isAutoFillingRegion: false,
      orthophotoLayer: null,
      orthophotoOverlayIndex: null,
      operationalDayOptions: [
        { value: '0', label: 'global.filter.all' },
        { value: '1', label: 'global.days.monday' },
        { value: '2', label: 'global.days.tuesday' },
        { value: '3', label: 'global.days.wednesday' },
        { value: '4', label: 'global.days.thursday' },
        { value: '5', label: 'global.days.friday' },
        { value: '6', label: 'global.days.saturday' },
        { value: '7', label: 'global.days.sunday' },
      ],
      formErrors: {},
      optionItems: [
        {
          key: 'hours',
          items: Array.from({ length: 24 }, (_, i) => i),
        },
        {
          key: 'minutes',
          items: Array.from({ length: 60 }, (_, i) => i),
        },
      ],
    }
  },
  computed: {
    google: gmapApi,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagData: 'identity/getFeatureFlagData',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    orthophotoIds() {
      return this.$store.state.orthophoto?.ids || []
    },
    orthophotoBounds() {
      return this.$store.state.orthophoto?.bounds || null
    },
    orthophotoEnabled() {
      return !!this.$store.state.orthophoto?.enabled
    },
    orthophotoAutoZoom() {
      return !!this.$store.state.orthophoto?.autoZoom
    },
    orthophotoIsLoaded() {
      return !!this.$store.state.orthophoto?.isLoaded
    },
    orthophotoToken() {
      return this.$store.state.orthophoto?.token || ''
    },
    title() {
      return this.$store.state.masterAddress.status == 'customer'
        ? this.$route.params.id === undefined
          ? this.$t('master.form.address.addCustomer')
          : this.$t('master.form.address.detailCustomer')
        : this.$route.params.id === undefined
        ? this.$t('master.form.address.addCompany')
        : this.$t('master.form.address.detailCompany')
    },
    items() {
      let items = []
      if (
        this.$route.name === 'Master Address Update' ||
        this.$route.name === 'Master Address Create'
      )
        items = this.masterItems
      else if (
        this.$route.name === 'Company Profile Address' ||
        this.$route.name === 'Company Profile Address Update'
      )
        items = this.settingItems

      return items
    },
    masterItems() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.address'),
          to: '/master/address',
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$store.state.masterAddress.status == 'customer'
                ? this.$t('master.form.address.addCustomer')
                : this.$t('master.form.address.addCompany')
              : this.form.location_name,
          active: true,
        },
      ]
    },
    settingItems() {
      return [
        {
          text: 'Pengaturan',
          to: '/setting',
        },
        {
          text: 'Profil Perusahaan',
          to: '/setting/company/',
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$t('master.form.address.addCompany')
              : this.form.location_name,
          active: true,
        },
      ]
    },
    oldData() {
      if (this.geofence?.geofence !== undefined) {
        let old = this.geofence.geofence
        old.customer = [{ name: old.customerName, id: old.customerId }]
        if (this.map_radio == 'circle') {
          let latLang = []
          if (this.geofence.geofence.circData !== null) {
            let circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
            let circleArray = circData.split('),')
            old.radius = circleArray[1]
            latLang = circleArray[0].replace('(', '').split(',')
          }
          old.circle_data = latLang
          old.poly_data = []
          old.thirdPartyId = this.geofence.geofence.thirdPartyId
        } else {
          let newPoly = []
          if (this.geofence.geofence.polyData !== null) {
            let polyData = this.geofence.geofence.polyData
            let polyArray = polyData.split('),')
            polyArray.forEach(function (item) {
              newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
            })
          }
          old.poly_data = newPoly
          old.circle_data = []
          old.radius = null
          old.thirdPartyId = this.geofence.geofence.thirdPartyId
        }
        return old
      }

      return {}
    },
    filteredOptions() {
      let options = this.categoryOptions
      if (this.isHQ) {
        options = options.filter((item) => item !== 'Kantor Pusat')
      }
      return options
    },
    citySelectKey() {
      const provinceKey = this.getRegionSelectKey(this.fullObject.province)
      return `city-${provinceKey}`
    },
    districtSelectKey() {
      const provinceKey = this.getRegionSelectKey(this.fullObject.province)
      const cityKey = this.getRegionSelectKey(this.fullObject.city)

      return `district-${provinceKey}-${cityKey}`
    },
    resourcefulQuery() {
      return {
        sectors: (opts) => {
          let options = this.categoryOptions
          let result = {}
          if (this.isHQ) {
            options = options.filter((item) => item !== 'Kantor Pusat')
          }

          if (opts.search)
            options = options.filter((option) => this.isContains(opts.search, option))

          const optionsObj = options.map((item) => {
            return {
              key: item,
              label: item,
            }
          })

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: optionsObj,
            },
          }

          return result
        },
        provinces: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
          }

          const { data, pagination } = await this.searchProvinces(filter)

          const provinceOptions = this.prependFallbackOption(
            (data || []).map((item) => ({
              key: item.name,
              regionId: item.regionId,
              label: item.name,
            })),
            this.fullObject.province,
            opts
          )

          return {
            metadata: {
              total_count: Math.max(pagination?.total || 0, provinceOptions.length),
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: provinceOptions,
            },
          }
        },
        cities: async (opts) => {
          const cityFallbackOption = this.fullObject.city
          if (this.isInvalidRegion(this.fullObject.province)) {
            const fallbackOptions = cityFallbackOption?.key ? [cityFallbackOption] : []

            return {
              metadata: {
                total_page: 1,
                total_count: fallbackOptions.length,
                page: 1,
              },
              data: {
                paginated_result: fallbackOptions,
              },
            }
          }

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
            provinceId: this.fullObject.province?.regionId,
          }

          const { data, pagination } = await this.searchCities(filter)

          const cityOptions = this.prependFallbackOption(
            (data || []).map((item) => ({
              key: item.name,
              regionId: item.regionId,
              label: item.name,
              province: item.province,
            })),
            this.fullObject.city,
            opts
          )

          return {
            metadata: {
              total_count: Math.max(pagination?.total || 0, cityOptions.length),
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: cityOptions,
            },
          }
        },
        districts: async (opts) => {
          const districtFallbackOption = this.fullObject.district
          if (
            this.isInvalidRegion(this.fullObject.province) ||
            this.isInvalidRegion(this.fullObject.city)
          ) {
            const fallbackOptions = districtFallbackOption?.key ? [districtFallbackOption] : []

            return {
              metadata: {
                total_page: 1,
                total_count: fallbackOptions.length,
                page: 1,
              },
              data: {
                paginated_result: fallbackOptions,
              },
            }
          }

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
            provinceId: this.fullObject.province?.regionId,
            cityId: this.fullObject.city?.regionId,
          }

          const { data, pagination } = await this.searchDistricts(filter)

          const districtOptions = this.prependFallbackOption(
            (data || []).map((item) => ({
              key: item.name,
              regionId: item.regionId,
              label: item.name,
            })),
            this.fullObject.district,
            opts
          )

          return {
            metadata: {
              total_count: Math.max(pagination?.total || 0, districtOptions.length),
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: districtOptions,
            },
          }
        },
        customer: (opts) => {
          return this.getCustomer(opts)
        },
      }
    },
    isGeofenceContactFormFlagActive() {
      return this.getFeatureFlagData('geofence_contact_form_disable').value
    },
    operationalTime() {
      // If operationalDay includes 0 (Semua/All), return empty object
      if (this.form.operationalDay && this.form.operationalDay.includes('0')) {
        return {}
      }

      const dayMapping = {
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday',
        7: 'sunday',
      }

      const result = {}

      if (this.form.operationalDay && this.form.operationalDay.length > 0) {
        // TODO: Uncomment when each operational day using each service start and service end
        // const timeSlot = {
        //   ...(this.form.serviceStart && {
        //     startTime: moment(this.form.serviceStart, 'HH:mm').format('HH:mm:ss'),
        //   }),
        //   ...(this.form.serviceEnd && {
        //     endTime: moment(this.form.serviceEnd, 'HH:mm').format('HH:mm:ss'),
        //   })
        // }
        this.form.operationalDay.forEach((dayValue) => {
          const dayName = dayMapping[dayValue]
          if (dayName) {
            // TODO: Uncomment when each operational day using each service start and service end
            // result[dayName] = Object.keys(timeSlot).length > 0 ? [timeSlot] : []
            result[dayName] = []
          }
        })
      }

      return result
    },
  },
  watch: {
    'form.province': function (newValue, oldValue) {
      if (
        newValue !== null &&
        newValue !== oldValue &&
        !this.isAutoFillingRegion &&
        !this.isInitSearchRegion
      ) {
        this.changeProvince()
      }
    },
    'form.city': function (newValue, oldValue) {
      if (
        newValue !== null &&
        newValue !== oldValue &&
        !this.isAutoFillingRegion &&
        !this.isInitSearchRegion
      ) {
        this.changeCity()
      }
    },
    orthophotoEnabled(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.refreshOrthophotoLayer()
        } else {
          this.removeOrthophotoLayer()
        }
      }
    },
    orthophotoIds(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshOrthophotoLayer()
      }
    },
  },
  async mounted() {
    const self = this
    await this.$refs.MapAddress.$mapPromise.then((map) => {
      self.map = map
    })
    this.refreshOrthophotoLayer()
    if (this.id) {
      this.hideForm = false
    }

    setTimeout(() => {
      let input = document.getElementById('search-address')

      const searchBox = new this.google.maps.places.SearchBox(input)

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener('places_changed', () => {
        this.isEdit = false
        const places = searchBox.getPlaces()
        if (places.length == 0) return

        this.$set(this.form, 'location_name', places[0].name)

        this.searchPlace()
      })
    }, 200)
  },

  beforeDestroy() {
    this.removeOrthophotoLayer()
  },

  methods: {
    createOrthophotoLayer() {
      if (
        !this.map ||
        !this.orthophotoEnabled ||
        !this.orthophotoIds?.length ||
        !this.orthophotoToken
      )
        return null
      const layer = new this.google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
          if (!this.shouldLoadTile(coord.x, coord.y, zoom)) return null
          const companyId = this.getCompanyId()
          const ids = (this.orthophotoIds || []).join(',')
          return `${process.env.VUE_APP_API_ORTHOPHOTO_URL}/tiles/${zoom}/${coord.x}/${
            coord.y
          }?company_id=${companyId}&ids=${ids}&token=${encodeURIComponent(this.orthophotoToken)}`
        },
        tileSize: new this.google.maps.Size(256, 256),
        name: 'Orthophoto',
        opacity: 1.0,
      })
      return layer
    },
    refreshOrthophotoLayer() {
      if (!this.map) return
      if (!this.orthophotoEnabled) {
        this.removeOrthophotoLayer()
        return
      }
      const layer = this.createOrthophotoLayer()
      if (!layer) return
      if (this.orthophotoOverlayIndex !== null) {
        this.map.overlayMapTypes.removeAt(this.orthophotoOverlayIndex)
        this.orthophotoOverlayIndex = null
      }
      this.orthophotoLayer = layer
      this.map.overlayMapTypes.push(layer)
      this.orthophotoOverlayIndex = this.map.overlayMapTypes.getLength() - 1
    },

    removeOrthophotoLayer() {
      if (!this.map) return
      if (!this.orthophotoLayer) return

      const overlays = this.map.overlayMapTypes
      const layers = overlays.getArray()
      const index = layers.indexOf(this.orthophotoLayer)

      if (index !== -1) {
        overlays.removeAt(index)
      }

      this.orthophotoLayer = null
      this.orthophotoOverlayIndex = null
    },

    tileToLatLngBounds(x, y, z) {
      const n = Math.pow(2, z)
      const lonLeft = (x / n) * 360 - 180
      const lonRight = ((x + 1) / n) * 360 - 180
      const latTop = (Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n))) * 180) / Math.PI
      const latBottom = (Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / n))) * 180) / Math.PI
      return {
        minX: lonLeft,
        minY: latBottom,
        maxX: lonRight,
        maxY: latTop,
      }
    },
    tileToMercatorBounds(x, y, z) {
      const n = Math.pow(2, z)
      const lonLeft = (x / n) * 360 - 180
      const lonRight = ((x + 1) / n) * 360 - 180
      const latTop = (Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n))) * 180) / Math.PI
      const latBottom = (Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / n))) * 180) / Math.PI
      const top = this.latLngToMercator(latTop)
      const bottom = this.latLngToMercator(latBottom)
      const left = this.lonToMercator(lonLeft)
      const right = this.lonToMercator(lonRight)
      return {
        minX: left,
        minY: bottom,
        maxX: right,
        maxY: top,
      }
    },
    lonToMercator(lon) {
      const R = 6378137
      return (lon * Math.PI * R) / 180
    },
    latLngToMercator(lat) {
      const R = 6378137
      const rad = (lat * Math.PI) / 180
      return R * Math.log(Math.tan(Math.PI / 4 + rad / 2))
    },
    mercatorToLatLng(y) {
      const R = 6378137
      const rad = 2 * Math.atan(Math.exp(y / R)) - Math.PI / 2
      return (rad * 180) / Math.PI
    },
    boundsIntersect(a, b) {
      if (!a || !b) return false
      const noOverlap = a.maxX < b.minX || a.minX > b.maxX || a.maxY < b.minY || a.minY > b.maxY
      return !noOverlap
    },
    shouldLoadTile(x, y, z) {
      if (!this.orthophotoEnabled) return false
      if (!this.orthophotoBounds) return false
      const isLatLng =
        Math.abs(this.orthophotoBounds.minX) <= 180 &&
        Math.abs(this.orthophotoBounds.maxX) <= 180 &&
        Math.abs(this.orthophotoBounds.minY) <= 90 &&
        Math.abs(this.orthophotoBounds.maxY) <= 90
      const tBounds = isLatLng
        ? this.tileToLatLngBounds(x, y, z)
        : this.tileToMercatorBounds(x, y, z)
      return this.boundsIntersect(tBounds, this.orthophotoBounds)
    },
    async getCustomer(params) {
      const res = await customerApi.get(params)
      return res
    },

    async searchProvinces(filter) {
      const response = await this.$apollo.query({
        query: GET_PROVINCES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.provinces?.data || [],
        pagination: response?.data?.data?.provinces?.pagination || {},
      }
    },

    async searchCities(filter) {
      const response = await this.$apollo.query({
        query: GET_CITIES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.cities?.data || [],
        pagination: response?.data?.data?.cities?.pagination || {},
      }
    },

    async searchDistricts(filter) {
      const response = await this.$apollo.query({
        query: GET_DISTRICTS,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.districts?.data || [],
        pagination: response?.data?.data?.districts?.pagination || {},
      }
    },

    normalizeRegionName(value) {
      if (typeof value !== 'string') return ''
      return value.trim().toLowerCase()
    },

    findExactRegionByName(rows, expectedName) {
      if (!Array.isArray(rows) || !expectedName) return null
      const normalizedExpectedName = this.normalizeRegionName(expectedName)

      return (
        rows.find((item) => this.normalizeRegionName(item?.name) === normalizedExpectedName) || null
      )
    },

    buildRegionOption(name, regionId = null) {
      if (!name) {
        return {
          regionId: null,
          key: null,
          label: null,
        }
      }

      return {
        regionId,
        key: name,
        label: name,
      }
    },

    isInvalidRegion(region) {
      return region?.regionId == null && Boolean(region?.key)
    },

    getRegionSelectKey(region) {
      if (region?.regionId) return region.regionId
      if (this.isInvalidRegion(region)) {
        return `fallback-${this.normalizeRegionName(region.key)}`
      }

      return 'empty'
    },

    prependFallbackOption(options, fallbackOption, opts) {
      if (!Array.isArray(options)) return []
      if (opts?.page !== 1) return options
      if (!this.isInvalidRegion(fallbackOption)) return options

      const selectedName = this.normalizeRegionName(fallbackOption.key)
      const searchTerm = this.normalizeRegionName(opts?.search)
      const isSearchMatch = !searchTerm || selectedName.includes(searchTerm)

      if (!isSearchMatch) return options

      const isAlreadyInOptions = options.some(
        (item) => this.normalizeRegionName(item?.key || item?.name) === selectedName
      )

      if (isAlreadyInOptions) return options

      return [fallbackOption, ...options]
    },

    async searchInitialRegion() {
      try {
        this.isInitSearchRegion = true

        const geofenceProvince = this.geofence.geofence.province
        const geofenceCity = this.geofence.geofence.city
        const geofenceDistrict = this.geofence.geofence.district

        let provinceOption = this.buildRegionOption(null)
        if (geofenceProvince) {
          const { data: provinceData } = await this.searchProvinces({
            pagination: {
              page: 1,
              show: 50,
            },
            search: geofenceProvince,
          })

          const selectedProvince = this.findExactRegionByName(provinceData, geofenceProvince)

          provinceOption = selectedProvince
            ? this.buildRegionOption(selectedProvince.name, selectedProvince.regionId)
            : this.buildRegionOption(geofenceProvince, null)
        }

        this.form.province = provinceOption.key
        this.$set(this.fullObject, 'province', provinceOption)

        let cityOption = this.buildRegionOption(null)
        const shouldFallbackCity = this.isInvalidRegion(provinceOption)

        if (geofenceCity) {
          if (shouldFallbackCity) {
            cityOption = this.buildRegionOption(geofenceCity, null)
          } else {
            const { data: cityData } = await this.searchCities({
              pagination: {
                page: 1,
                show: 50,
              },
              search: geofenceCity,
              provinceId: provinceOption.regionId,
            })

            const selectedCity = this.findExactRegionByName(cityData, geofenceCity)

            cityOption = selectedCity
              ? this.buildRegionOption(selectedCity.name, selectedCity.regionId)
              : this.buildRegionOption(geofenceCity, null)
          }
        }

        this.form.city = cityOption.key
        this.$set(this.fullObject, 'city', cityOption)

        let districtOption = this.buildRegionOption(null)
        const shouldFallbackDistrict =
          this.isInvalidRegion(provinceOption) || this.isInvalidRegion(cityOption)

        if (geofenceDistrict) {
          if (shouldFallbackDistrict) {
            districtOption = this.buildRegionOption(geofenceDistrict, null)
          } else {
            const { data: districtData } = await this.searchDistricts({
              pagination: {
                page: 1,
                show: 50,
              },
              search: geofenceDistrict,
              provinceId: provinceOption.regionId,
              cityId: cityOption.regionId,
            })

            const selectedDistrict = this.findExactRegionByName(districtData, geofenceDistrict)

            districtOption = selectedDistrict
              ? this.buildRegionOption(selectedDistrict.name, selectedDistrict.regionId)
              : this.buildRegionOption(geofenceDistrict, null)
          }
        }

        this.form.district = districtOption.key
        this.$set(this.fullObject, 'district', districtOption)
      } finally {
        await this.$nextTick()
        this.isInitSearchRegion = false
      }
    },

    async initEditPage() {
      this.isEdit = true
      this.form.location_name = this.geofence.geofence.fenceName
      this.form.address = this.geofence.geofence.address
      this.form.address_detail = this.geofence.geofence.addressDetail

      this.form.postal_code = this.geofence.geofence.postalCode
      this.form.sector = this.geofence.geofence.category
      this.fullObject.sector = {
        key: this.geofence.geofence.category,
        label: this.geofence.geofence.category,
      }

      this.form.contact_person = this.geofence.geofence.contactName
      this.form.phone_no = this.geofence.geofence.phoneNo
      this.form.is_garage = this.geofence.geofence.isGarage
      this.form.is_service = this.geofence.geofence.isServiceLoc
      this.form.is_billingAddr = this.geofence.geofence.isBillingAddr
      this.form.is_depot = this.geofence.geofence.isDepot
      this.form.serviceStart = this.geofence.geofence.serviceStart
      this.form.serviceEnd = this.geofence.geofence.serviceEnd
      this.form.serviceDuration = this.geofence.geofence.serviceDuration
      this.form.service_location = this.geofence.geofence.serviceLocType
      this.fullObject.customer = this.geofence.geofence.customerId
        ? { id: this.geofence.geofence.customerId, name: this.geofence.geofence.customerName }
        : {}
      this.form.customer = this.geofence.geofence.customerId
      this.form.contacts = this.geofence.geofence.contacts
      this.form.reference_id = this.geofence.geofence.thirdPartyId

      await this.searchInitialRegion()

      // Handle operationalTime to operationalDay conversion
      if (this.geofence.geofence.operationalTime && this.state === 'customer') {
        const operationalTime = this.geofence.geofence.operationalTime

        // Check if operationalTime is empty object (means "Semua"/All days)
        if (Object.keys(operationalTime).length === 0) {
          this.form.operationalDay = ['0']
        } else {
          // Map day names back to day numbers
          const dayMapping = {
            monday: '1',
            tuesday: '2',
            wednesday: '3',
            thursday: '4',
            friday: '5',
            saturday: '6',
            sunday: '7',
          }

          const selectedDays = []
          Object.keys(operationalTime).forEach((dayName) => {
            selectedDays.push(dayMapping[dayName])
          })

          this.form.operationalDay = selectedDays.length > 0 ? selectedDays : [0]
        }
      }

      this.map_radio = this.geofence.geofence.type == 'C' ? 'circle' : 'polygon'

      if (this.map_radio == 'circle') {
        let circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
        let circleArray = circData.split('),')
        this.form.radius = circleArray[1]
        this.form.latLang = circleArray[0] + ')'
        let latLang = circleArray[0].replace('(', '').split(',')

        this.form.circle_data = latLang

        this.map.panTo({
          lat: parseFloat(latLang[0]),
          lng: parseFloat(latLang[1]),
        })
        this.form.latitude = latLang[0]
        this.form.longitude = latLang[1]
        this.map.setZoom(17)

        this.initMapCircle([latLang[0], latLang[1]])
      } else {
        let polyData = this.geofence.geofence.polyData
        this.form.latLang = polyData.slice(1, -1)
        this.form.radius = null
        let polyArray = polyData.split('),')
        let newPoly = []
        polyArray.forEach(function (item) {
          newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
        })

        this.form.poly_data = newPoly
        this.initMapPoly(newPoly)
      }
    },

    initMapCircle(places = []) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
      }

      this.circle = new this.google.maps.Circle({
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        map: this.map,
        radius: parseInt(this.form.radius),
        editable: true,
        draggable: true,
      })
      let circle = this.circle

      this.circle.setMap(null)
      this.circle.setMap(this.map)

      this.circle.setCenter({
        lat: parseFloat(places[0]),
        lng: parseFloat(places[1]),
      })

      this.map.fitBounds(this.circle.getBounds())

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.updateCircleCoordsState(circle)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.updateCircleCoordsState(circle)
      })
    },

    initMapPoly(places = []) {
      if (places.length === 0) return
      if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
      }

      let coords = []

      if (places.length === 1) {
        const lat = parseFloat(places[0][0])
        const lng = parseFloat(places[0][1])

        coords = [
          {
            lat: lat - 1 / 1000,
            lng: lng + 1 / 1000,
          },
          {
            lat: lat - 1 / 1000,
            lng: lng - 1 / 1000,
          },
          {
            lat: lat + 1 / 1000,
            lng: lng - 1 / 1000,
          },
          {
            lat: lat + 1 / 1000,
            lng: lng + 1 / 1000,
          },
        ]
      } else {
        places.forEach(function (item) {
          coords.push({
            lat: parseFloat(item[0]),
            lng: parseFloat(item[1]),
          })
        })
      }

      // Construct the polygon.
      this.polygon = new this.google.maps.Polygon({
        paths: coords,
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      })
      this.polygon.setMap(null)
      this.polygon.setMap(this.map)

      const bounds = new this.google.maps.LatLngBounds()
      coords.forEach((item) => {
        bounds.extend({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) })
      })

      this.map.fitBounds(bounds)

      this.polygon.getPaths().forEach((path) => {
        this.google.maps.event.addListener(path, 'insert_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'remove_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'set_at', () => {
          this.updatePolygonCoordsState(path)
        })
      })
    },

    initGeofence(location) {
      if (!Array.isArray(location) || location.length !== 2) return
      if (this.map_radio === 'circle') {
        this.initMapCircle(location)
      } else {
        this.initMapPoly([location])
      }
    },

    getCenterpoint(latlong) {
      const coords = latlong.map(([lat, lng]) => ({ lat, lng }))
      let bounds = new this.google.maps.LatLngBounds()
      coords.forEach((element) => {
        bounds.extend(element)
      })
      const center = bounds.getCenter()
      return { lat: center.lat(), long: center.lng() }
    },

    async getLocation() {
      try {
        if (this.map_radio === 'circle') {
          if (this.circle == null) return

          this.form.latitude = this.circle.center.lat()
          this.form.longitude = this.circle.center.lng()
          this.form.radius = this.circle.getRadius()

          this.form.circle_data = [this.form.latitude, this.form.longitude]
          this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
        } else if (this.map_radio === 'polygon') {
          if (this.polygon == null) return

          let latLang = []
          for (let i = 0; i < this.polygon.getPath().getLength(); i++) {
            let lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
            let lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)

            this.form.poly_data.push([lat, lang])
            latLang.push('(' + lat + ', ' + lang + ')')
          }

          this.form.latLang = latLang.join(', ')
          const float_data = this.form.poly_data.map(([lat, lng]) => [
            parseFloat(lat),
            parseFloat(lng),
          ])
          const center = this.getCenterpoint(float_data)
          this.form.latitude = center.lat
          this.form.longitude = center.long
        }

        await this.getPlace(this.form.longitude, this.form.latitude)
      } finally {
        this.loading = false
      }
    },

    async getPlace(lon, lat) {
      this.isFirstInitialization = true
      this.isAutoFillingRegion = true
      const useCache = this.isUsingCache()
      let data = null

      if (useCache) {
        const reverse = await getGeolocation({ lat, lon })
        const address = getAddress(reverse, lat, lon)
        if (address) data = { ...address, address: address.name }
      } else {
        const { display_name } = await GetAddressData(lat, lon)
        data = {
          address: display_name,
        }
      }

      const { data: regionData } = await this.$apollo.query({
        query: GET_REGION_BY_LAT_LNG,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            latitude: lat,
            longitude: lon,
          },
        },
      })

      const provinceData = regionData?.data?.regionByLatLng?.province
      const cityData = regionData?.data?.regionByLatLng?.city
      const districtData = regionData?.data?.regionByLatLng?.district

      data = {
        ...data,
        province: provinceData?.name || null,
        city: cityData?.name || null,
        district: districtData?.name || null,
      }

      if (!data) {
        const emptyRegionData = {
          regionId: null,
          key: null,
          label: null,
        }

        this.$set(this.fullObject, 'province', {
          ...emptyRegionData,
        })

        this.$set(this.fullObject, 'city', {
          ...emptyRegionData,
        })

        this.$set(this.fullObject, 'district', {
          ...emptyRegionData,
        })

        this.form = { ...this.form, address: null, province: null, city: null, district: null }

        await this.$nextTick()
        this.isAutoFillingRegion = false
        return
      }

      this.form = {
        ...this.form,
        address: data.address,
        province: data.province,
        city: data.city,
        district: data.district,
      }

      this.$set(this.fullObject, 'province', {
        regionId: provinceData?.regionId || null,
        key: provinceData?.name || null,
        label: provinceData?.name || null,
      })

      this.$set(this.fullObject, 'city', {
        regionId: cityData?.regionId || null,
        key: cityData?.name || null,
        label: cityData?.name || null,
      })

      this.$set(this.fullObject, 'district', {
        regionId: districtData?.regionId || null,
        key: districtData?.name || null,
        label: districtData?.name || null,
      })

      await this.$nextTick()
      this.isAutoFillingRegion = false
    },

    changeGeoType(item) {
      if (item == 'polygon') {
        this.form.radius = null
      } else if (item == 'circle') {
        this.form.radius = 100
      }

      let coords = []
      let lat = this.form.latitude
      let lng = this.form.longitude

      if (item === 'circle') {
        if (this.places.length > 0) {
          const place = this.places[0]

          lat = place.geometry.location.lat
          lng = place.geometry.location.lng
        } else if (this.form.poly_data.length > 0) {
          [lat, lng] = this.convertPolyDataToLatLng(this.form.poly_data)
        }

        if (lat === '' || lng === '') return

        coords = [lat, lng]

        if (this.polygon !== null) {
          this.polygon.setMap(null)
          this.polygon = null
          this.poly_error = false
          this.form.poly_data = []
        }

        this.initMapCircle(coords)

        this.form.latitude = this.circle.center.lat()
        this.form.longitude = this.circle.center.lng()
        this.form.radius = this.circle.getRadius()

        this.form.circle_data = [this.form.latitude, this.form.longitude]
        this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'

        return
      }

      if (this.places.length > 0) {
        const place = this.places[0]

        lat = place.geometry.location.lat
        lng = place.geometry.location.lng
      }

      if (lat === '' || lng === '') return

      coords = [[lat, lng]]

      if (this.circle !== null) {
        this.circle.setMap(null)
        this.circle = null
        this.circle_error = false
        this.form.circle_data = []
      }

      this.initMapPoly(coords)

      let latLang = []
      for (let i = 0; i < this.polygon.getPath().getLength(); i++) {
        let koma = ''
        if (this.polygon.getPath().getLength() - 1 != i) {
          koma = ','
        }

        let lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
        let lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)
        this.form.latitude += lat + koma
        this.form.longitude += lang + koma

        this.form.poly_data.push([lat, lang])
        latLang.push('(' + lat + ', ' + lang + ')')
      }

      this.form.latLang = latLang.join(', ')
      this.form.radius = null
    },

    setLocation() {
      this.loading = true
      setTimeout(() => {
        this.getLocation()
      }, 1200)
      this.hideForm = false
    },

    handleSetRadius: debounce(function () {
      if (this.circle != null && this.form.radius) {
        this.circle.setRadius(parseInt(this.form.radius))
        this.map.fitBounds(this.circle.getBounds())
      }
    }, 500),

    deleteVector() {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
        this.$set(this.form, 'radius', 100)
      } else if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
        this.$set(this.form, 'radius', null)
      }

      this.$set(this.form, 'latLang', '')
    },

    onChangeNumber() {
      let text = this.form.phone_no
      const conditions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')', '-']
      for (let i = 0; i < text.length; i++) {
        let state = false
        for (let j = 0; j < conditions.length; j++) {
          if (conditions[j] == text[i]) {
            state = true
            break
          }
        }
        if (state == false) {
          this.form.phone_no = null
          break
        }
      }
    },

    checkEmpty() {
      let isEmpty = true
      let forms = this.form
      let customer = ['poly_data', 'circle_data', 'is_garage', 'radius']
      let general = [...customer, 'customer']
      let excepts = this.state == 'customer' ? customer : general
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (!forms[key][subKey]) {
                  isEmpty = true
                } else {
                  isEmpty = false
                }
              })
            }
          }
        }
      })

      return isEmpty
    },

    checkChanged() {
      let isChanged = false
      let forms = this.form
      let formOld = this.oldData
      let excepts = ['latLang', 'longitude', 'latitude', 'customer']
      let formField = {
        sector: 'category',
        location_name: 'fenceName',
        address: 'address',
        province: 'province',
        city: 'city',
        district: 'district',
        postal_code: 'postalCode',
        contact_person: 'contactName',
        phone_no: 'phoneNo',
        radius: 'radius',
        latitude: 'latitude',
        longitude: 'longitude',
        serviceStart: 'serviceStart',
        serviceEnd: 'serviceEnd',
        circle_data: 'circle_data',
        poly_data: 'poly_data',
        address_detail: 'addressDetail',
        is_garage: 'isGarage',
        is_service: 'isServiceLoc',
        is_billingAddr: 'isBillingAddr',
        is_depot: 'isDepot',
        service_location: 'serviceLocType',
        reference_id: 'thirdPartyId',
      }
      Object.keys(this.form).forEach(function (key) {
        if (!excepts.includes(key)) {
          if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
            if (key == 'circle_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else if (key == 'poly_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else {
              isChanged = true
            }
          }
        }
      })
      return isChanged
    },

    toCancel() {
      let isEmpty = this.checkEmpty()

      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }

      if (isEmpty) {
        this.$router.go(-1)
      } else {
        Swal.fire({
          title: this.$t('global.alert.text.cancel'),
          text: this.$t('global.alert.text.confirmCancel'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('global.yes'),
          cancelButtonText: this.$t('global.no'),
        }).then((result) => {
          if (result.value) {
            this.$router.go(-1)
          }
        })
      }
    },

    updatePolygonCoordsState(poly) {
      this.form.poly_data = []

      let latLang = []
      for (let i = 0; i < poly.getLength(); i++) {
        let koma = ''
        if (poly.getLength() - 1 != i) {
          koma = ','
        }

        let lat = parseFloat(poly.getAt(i).lat()).toFixed(8)
        let lang = parseFloat(poly.getAt(i).lng()).toFixed(8)
        this.form.latitude += lat + koma
        this.form.longitude += lang + koma

        this.form.poly_data.push([lat, lang])
        latLang.push('(' + lat + ', ' + lang + ')')
      }

      this.form.latLang = latLang.join(', ')
    },

    updateCircleCoordsState(circle) {
      this.form.latitude = circle.center.lat()
      this.form.longitude = circle.center.lng()
      this.form.radius = circle.getRadius()

      this.form.circle_data = [this.form.latitude, this.form.longitude]
      this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
    },

    changeProvince() {
      this.form.city = null
      this.form.district = null
      this.$set(this.fullObject, 'city', { regionId: null, key: null, label: null })
      this.$set(this.fullObject, 'district', { regionId: null, key: null, label: null })
    },

    changeCity() {
      this.form.district = null
      this.$set(this.fullObject, 'district', { regionId: null, key: null, label: null })
    },

    checkGarage() {
      this.resetForm()
      if (this.form.contacts[0].sendWhatsapp) {
        if (!this.form.contacts[0].name || !this.form.contacts[0].phoneNo) {
          this.$mcToast.error(this.$t('global.validation.required'))
          return
        }
      }

      if (this.$route.params.id === undefined) return this.toSave()
      let isGarage = this.form.is_garage
      let oldGarage = this.oldData.isGarage
      if (oldGarage === true) {
        if (isGarage === false) {
          this.$bvModal.show('modal-change-data')
          return
        }
      }
      this.toSave()
    },

    getErrorMessageToast(message, defaultErrMsg) {
      let errMsg = defaultErrMsg

      if (message == 'Error: "Geofence name already exists"') {
        this.invalid = true
        this.duplicateLocation = true
        errMsg = `${this.$t('master.form.address.geofenceAlreadyExists')}`
      } else if (message == 'Error: "thirdPartyId already exists"') {
        this.invalid = true
        this.duplicateReferenceId = true
        errMsg = `${this.$t('master.form.address.referenceId')} ${this.$t(
          'global.alert.text.alreadyExist'
        )}`
        this.$set(this.formErrors, 'reference_id', ' ')
      } else if (message == 'Error: "ServiceStart is Required"') {
        errMsg = `${this.$t('master.form.address.serviceStart')} ${this.$t(
          'global.validation.required'
        )}`
        this.$set(this.formErrors, 'service_start', ' ')
      } else if (message == 'Error: "ServiceEnd is Required"') {
        errMsg = `${this.$t('master.form.address.serviceEnd')} ${this.$t(
          'global.validation.required'
        )}`
        this.$set(this.formErrors, 'service_end', ' ')
      } else if (message == 'Geofence is being used in a Voice Announcer') {
        errMsg = `${this.$t('master.form.address.enterVA')}`
        this.$set(this.formErrors, 'service_end', ' ')
      } else if (message == 'Error: "Service duration must be between 00:01:00 and 23:59:59"') {
        errMsg = `${this.$t('master.form.address.serviceDurationExceedLimit')}`
        this.$set(this.formErrors, 'service_duration', ' ')
      } else if (
        message ==
        'Error: "thirdPartyId can only contain letters, numbers, and the characters . _ -"'
      ) {
        errMsg = `${this.$t('master.form.address.referenceIdInvalidChar')}`
        this.$set(this.formErrors, 'reference_id', `${this.$t('setting.wrongFormat')}`)
      }

      return errMsg
    },

    toSave() {
      if (this.$refs.formRef.hasErrors) {
        this.$mcToast.error(this.$t('master.form.address.invalidFormat'))
        return
      }
      const form = this.convertNewData()
      this.isSubmit = true

      if (this.id !== undefined && this.id != 0) {
        let type = this.oldData.type == 'C' ? 'circle' : 'polygon'
        let oldData = {
          customerId: this.oldData.customer ? this.oldData.customer.id : null,
          customerName: this.oldData.customer ? this.oldData.customer.name : null,
          circData: this.oldData.circData,
          polyData: this.oldData.polyData,
          fenceName: this.oldData.fenceName,
          type: type,
          address: this.oldData.address,
          addressDetail: this.oldData.addressDetail,
          province: this.oldData.province,
          city: this.oldData.city,
          district: this.oldData.district,
          postalCode: this.oldData.postalCode,
          category: this.oldData.category,
          contactName: this.oldData.contactName,
          phoneNo: this.oldData.phoneNo,
          isGarage: this.oldData.isGarage,
          isServiceLoc: this.oldData.isServiceLoc,
          isBillingAddr: this.oldData.isBillingAddr,
          isDepot: this.oldData.isDepot,
          serviceStart: this.oldData.serviceStart,
          serviceEnd: this.oldData.serviceEnd,
          serviceDuration: this.oldData.serviceDuration,
          serviceLocType: this.oldData.serviceLocType,
          ...(!this.isGeofenceContactFormFlagActive && {
            contacts: this.oldData.contacts,
          }),
          operationalTime: this.state === 'customer' ? this.oldData.operationalTime : undefined,
          thirdPartyId: this.oldData.thirdPartyId,
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_ADDRESS,
            variables: {
              input: {
                geofenceId: parseInt(this.id),
                oldData: oldData,
                newData: form,
              },
            },
          })
          .then((response) => {
            if (response.data.updateGeofence.isSuccessful) {
              this.$apollo.queries.geofence.refetch()
              this.$mcToast.success(this.$t('master.address.alert.saved'))
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            } else {
              const errMsg = this.getErrorMessageToast(
                response.data.updateGeofence.message,
                this.$t('master.form.address.polygonMin')
              )
              this.isSubmit = false
              return this.$mcToast.error(errMsg)
            }
          })
      } else {
        this.$apollo
          .mutate({
            mutation: CREATE_ADDRESS,
            variables: {
              input: form,
            },
          })
          .then((response) => {
            if (response.data.createGeofence.isSuccessful) {
              this.trackGeofenceNotifWA(form)
              this.$apollo.queries.geofence.refetch()
              this.$mcToast.success(this.$t('master.address.alert.saved'))
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            } else {
              const errMsg = this.getErrorMessageToast(
                response.data.createGeofence.message,
                this.$t('master.form.address.invalidCoordinat')
              )
              this.isSubmit = false
              return this.$mcToast.error(errMsg)
            }
          })
      }
    },

    resetForm() {
      this.invalid = false
      this.duplicateLocation = false
      this.duplicateReferenceId = false
      this.formErrors = {}
    },

    convertNewData() {
      let latLangData = {}
      let type = null
      let circleData = '<' + this.form.latLang + ',' + this.form.radius + '>'
      let polyData = this.form.latLang
      if (this.map_radio == 'circle') {
        latLangData = {
          circData: circleData,
          polyData: null,
        }
        type = 'circle'
      } else if (this.map_radio == 'polygon') {
        latLangData = {
          polyData: polyData,
          circData: null,
        }
        type = 'polygon'
      }

      let form = {
        ...latLangData,
        fenceName: this.form.location_name,
        customerId: this.state == 'customer' ? this.fullObject.customer.id : undefined,
        customerName: this.state == 'customer' ? this.fullObject.customer.name : undefined,
        type: type,
        address: this.form.address,
        addressDetail: this.form.address_detail,
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        postalCode: this.form.postal_code,
        category: this.form.sector,
        contactName: this.form.contact_person,
        phoneNo: this.form.phone_no,
        isGarage: this.form.is_garage,
        isServiceLoc: this.form.is_service,
        isBillingAddr: this.form.is_billingAddr,
        isDepot: this.form.is_depot,
        serviceStart: this.form.serviceStart
          ? moment(this.form.serviceStart, 'HH:mm').format('HH:mm:ss')
          : null,
        serviceEnd: this.form.serviceEnd
          ? moment(this.form.serviceEnd, 'HH:mm').format('HH:mm:ss')
          : null,
        serviceDuration: this.form.serviceDuration || null,
        serviceLocType: this.form.service_location,
        operationalTime: this.state === 'customer' ? this.operationalTime : undefined,
        ...(!this.isGeofenceContactFormFlagActive && {
          contacts: this.form.contacts,
        }),
        thirdPartyId: this.form.reference_id,
      }

      return form
    },

    trackGeofenceNotifWA(form) {
      this.track('Create Master Address', {
        notification_wa_geofence:
          form.contacts?.[0]?.name &&
          form.contacts?.[0]?.phoneNo &&
          form.contacts[0].sendWhatsapp &&
          (form.isBillingAddr || form.isGarage || form.isDepot || form.isServiceLoc)
            ? 'ON'
            : 'OFF',
        source: 'Create Manual',
      })
    },

    async getPlaceDetails(input) {
      const suggestions = await getPlacesAutocomplete(input)

      const safeSuggestions = Array.isArray(suggestions) ? suggestions : []
      const placePredictions = safeSuggestions
        .map((item) => item && item.placePrediction)
        .filter((p) => !!p)

      if (placePredictions.length === 0) {
        return null
      }

      const place = placePredictions[0]

      try {
        const loc = await getPlaceDetail(place.placeId)

        if (!loc) {
          return null
        }

        return {
          id: place.placeId,
          name: place.structuredFormat.mainText.text,
          address: place.structuredFormat.secondaryText.text,
          geometry: {
            location: {
              lat: parseFloat(loc.latitude),
              lng: parseFloat(loc.longitude),
            },
          },
        }
      } catch (e) {
        return null
      }
    },

    async getPlacePrediction(input) {
      try {
        const service = new google.maps.places.AutocompleteService()

        return new Promise((resolve) => {
          service.getPlacePredictions({ input: input, types: ['geocode'] }, (predictions) =>
            resolve(predictions)
          )
        })
      } catch (e) {
        return null
      }
    },

    async searchPlace() {
      const input = document.getElementById('search-address').value
      const place = await this.getPlaceDetails(input)

      if (place) {
        this.places = [place]

        const location = [place.geometry.location.lat, place.geometry.location.lng]

        this.initGeofence(location)

        this.setLocation()
      } else {
        const predictions = await this.getPlacePrediction(input)

        let defaultLat = -6.175269678262197
        let defaultLng = 106.82747008296978

        if (predictions && predictions.length > 0) {
          const predictionPlaceId = predictions[0].place_id
          const fallbackPlace = await this.getPlaceDetails(predictionPlaceId)

          if (fallbackPlace && fallbackPlace.geometry) {
            defaultLat = fallbackPlace.geometry.location.lat
            defaultLng = fallbackPlace.geometry.location.lng
          }
        }

        if (this.map) {
          this.map.setCenter({ lat: defaultLat, lng: defaultLng })
          this.map.setZoom(14)
        }

        this.initGeofence([defaultLat, defaultLng])

        this.form.location_name = null
        this.form.address = null

        this.hideForm = false
        this.loading = false
        this.$mcToast.warning(this.$t('master.list.address.addressNotFound'))
      }
    },

    convertPolyDataToLatLng(polyData) {
      // Create bounds object
      const bounds = new this.google.maps.LatLngBounds()

      // Add each coordinate pair to bounds
      for (let i = 0; i < polyData.length; i++) {
        const lat = parseFloat(polyData[i][0])
        const lng = parseFloat(polyData[i][1])
        bounds.extend({ lat, lng })
      }

      // Return center point of the bounds
      return [bounds.getCenter().lat(), bounds.getCenter().lng()]
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            size="medium"
            class="mx-2"
            variant="secondary"
            :text="$t('global.cancel')"
            icon="icon-outline_close"
            @click="toCancel"
          />
          <McButton
            size="medium"
            variant="primary"
            :disabled="isSubmit"
            :text="$t('global.save')"
            icon="icon-outline_save"
            @click="checkGarage"
          />
        </div>
      </div>
    </div>

    <FormulateForm ref="formRef" v-model="form" :errors="formErrors">
      <b-row>
        <b-col sm="12" md="7">
          <b-card>
            <b-row class="mc-form--address-search mb-2">
              <b-col md="10">
                <b-form-input
                  id="search-address"
                  v-model="searchLocation"
                  trim
                  autocomplete="off"
                  :placeholder="$t('master.form.address.searchLocation')"
                />
              </b-col>
              <b-col md="2">
                <McButton
                  variant="primary"
                  block
                  :text="$t('global.search')"
                  @click="searchPlace"
                />
              </b-col>
              <!-- TODO: disabled button on map background color still same as not disabled button -->
              <b-col md="12">
                <div class="mc-map-address-icon">
                  <a id="eraser" name="delete-form" value="eraser" @click="deleteVector">
                    <label for="eraser">
                      <i class="fas fa-eraser" />
                    </label>
                  </a>

                  <span>
                    <input
                      id="polygon"
                      v-model="map_radio"
                      type="radio"
                      name="map-radio"
                      value="polygon"
                      @input="changeGeoType('polygon')"
                    />
                    <label for="polygon">
                      <i class="fas fa-draw-polygon" />
                    </label>
                  </span>

                  <span>
                    <input
                      id="circle"
                      v-model="map_radio"
                      type="radio"
                      name="map-radio"
                      value="circle"
                      @input="changeGeoType('circle')"
                    />
                    <label for="circle">
                      <i class="fas fa-circle" />
                    </label>
                  </span>
                </div>
                <GmapMap
                  id="map"
                  ref="MapAddress"
                  :center="$store.state.map.center"
                  :zoom="parseFloat($store.state.map.zoom)"
                  class="mc-map-address mt-2"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col sm="12" md="5">
          <b-card>
            <b-row>
              <h4 class="card-title mb-4">
                {{ $t('setting.list.company.form.address') }}
              </h4>
              <template v-if="hideForm">
                <McEmptyState
                  :title="$t('master.form.address.emptyAddressInfoTitle')"
                  :desc="$t('master.form.address.emptyAddressInfoCaption')"
                  :hasButton="false"
                />
              </template>
              <template v-else>
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <LoadingSkeleton />
                  </template>

                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        id="location_name"
                        name="location_name"
                        :label="$t('master.form.address.name')"
                        :placeholder="$t('master.form.address.name')"
                        type="text"
                        help="required"
                        :validation="[
                          ['bail'],
                          ['required', 'trim'],
                          ['between', 0, 255, 'length'],
                          ['isDuplicate', duplicateLocation],
                        ]"
                        :validation-messages="{
                          required: `${$t('setting.list.company.form.location')} ${$t(
                            'global.validation.required'
                          )}`,
                          between: $t('setting.list.company.formAlert.locationLimit'),
                          isDuplicate: $t('setting.list.company.formAlert.location'),
                        }"
                        validation-behavior="live"
                        error-behavior="live"
                        @input="resetForm"
                      />
                    </div>
                  </b-col>

                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.sector"
                        type="select-resourceful-v2"
                        :label="$t('master.form.address.category')"
                        :placeholder="`${$t('global.form.select')} ${$t(
                          'master.form.address.category'
                        )}`"
                        validation="required"
                        help="required"
                        validation-behavior="live"
                        error-behavior="live"
                        :validation-messages="{
                          required: `${$t('setting.list.company.form.addressCategory')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                        :optionsGetter="resourcefulQuery.sectors"
                        :taggable="false"
                        :multiple="false"
                        trackBy="key"
                        :optionLabelFn="({ item }) => item.label"
                        :fullObject="fullObject.sector"
                        @update:fullObject="($event) => (fullObject.sector = $event)"
                      />
                    </div>
                  </b-col>

                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        id="reference_id"
                        name="reference_id"
                        :placeholder="$t('master.form.address.referenceId')"
                        :label="$t('master.form.address.referenceId')"
                        type="text"
                        :validation="[
                          ['bail'],
                          ['optional'],
                          ['matches', /\S/],
                          ['between', 0, 64, 'length'],
                          ['isDuplicate', duplicateReferenceId],
                        ]"
                        :validation-messages="{
                          matches: $t('master.form.address.referenceIdNoSpace'),
                          between: $t('master.form.address.referenceIdLimit'),
                          isDuplicate: $t('master.form.address.referenceIdDuplicate'),
                        }"
                        validation-behavior="live"
                        error-behavior="live"
                        @input="resetForm"
                      />
                    </div>
                  </b-col>

                  <b-col v-if="hasAccessAll(['tms:read']) && state == 'customer'" md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.customer"
                        :disabled="isEdit"
                        type="select-resourceful-v2"
                        :placeholder="`${$t('global.form.select')} ${$t(
                          'master.form.address.customer'
                        )}`"
                        :label="$t('master.form.address.customer')"
                        :optionsGetter="resourcefulQuery.customer"
                        :optionLabelFn="
                          ({ item }) => {
                            return item.name
                          }
                        "
                        :taggable="false"
                        :multiple="false"
                        trackBy="id"
                        :fullObject="fullObject.customer"
                        validation="required"
                        help="required"
                        validation-behavior="live"
                        error-behavior="live"
                        :validation-messages="{
                          required: `${$t('master.form.address.customer')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                        @update:fullObject="($event) => (fullObject.customer = $event)"
                      />
                    </div>
                  </b-col>

                  <b-col md="12" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        id="address"
                        name="address"
                        :label="$t('master.form.address.fullAddress')"
                        :placeholder="$t('master.form.address.fullAddress')"
                        type="textarea"
                        validation="required:trim"
                        help="required"
                        validation-behavior="live"
                        error-behavior="live"
                        :validation-messages="{
                          required: `${$t('setting.list.company.form.fullAddress')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                        class="address-form"
                      />
                    </div>
                  </b-col>
                  <!-- Province -->
                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.province"
                        type="select-resourceful-v2"
                        :disabled="isInitSearchRegion"
                        :placeholder="`${$t('global.form.select')} ${$t(
                          'master.form.address.province'
                        )}`"
                        :label="$t('master.form.address.province')"
                        validation="required"
                        help="required"
                        validation-behavior="live"
                        error-behavior="live"
                        :validation-messages="{
                          required: `${$t('master.form.address.province')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                        :optionsGetter="resourcefulQuery.provinces"
                        :taggable="false"
                        :multiple="false"
                        trackBy="key"
                        :optionLabelFn="({ item }) => item.label"
                        :fullObject="fullObject.province"
                        @update:fullObject="($event) => (fullObject.province = $event)"
                      />
                    </div>
                  </b-col>
                  <!-- City -->
                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        :key="citySelectKey"
                        v-model="form.city"
                        type="select-resourceful-v2"
                        :disabled="isInitSearchRegion"
                        :placeholder="`${$t('global.form.select')} ${$t(
                          'master.form.address.city'
                        )}`"
                        :label="$t('master.form.address.city')"
                        validation="required"
                        help="required"
                        validation-behavior="live"
                        error-behavior="live"
                        :validation-messages="{
                          required: `${$t('master.form.address.city')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                        :optionsGetter="resourcefulQuery.cities"
                        :taggable="false"
                        :multiple="false"
                        trackBy="key"
                        :optionLabelFn="({ item }) => item.label"
                        :fullObject="fullObject.city"
                        @update:fullObject="($event) => (fullObject.city = $event)"
                      />
                    </div>
                  </b-col>

                  <b-col md="6" sm="6">
                    <div class="mb-3">
                      <FormulateInput
                        :key="districtSelectKey"
                        v-model="form.district"
                        type="select-resourceful-v2"
                        :disabled="isInitSearchRegion"
                        :placeholder="`${$t('global.form.select')} ${$t(
                          'master.form.address.district'
                        )}`"
                        :label="$t('master.form.address.district')"
                        validation-behavior="live"
                        error-behavior="live"
                        :optionsGetter="resourcefulQuery.districts"
                        :taggable="false"
                        :multiple="false"
                        trackBy="key"
                        :optionLabelFn="({ item }) => item.label"
                        :fullObject="fullObject.district"
                        @update:fullObject="($event) => (fullObject.district = $event)"
                      />
                    </div>
                  </b-col>
                  <b-col md="6" sm="6">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.latLang"
                        :label="$t('master.form.address.latAndLong')"
                        :placeholder="$t('master.form.address.latAndLong')"
                        validation="required:trim"
                        help="required"
                        :validation-messages="{
                          required: `${$t('setting.list.company.form.longitude')} ${$t(
                            'global.validation.required'
                          )}`,
                        }"
                      />
                    </div>
                  </b-col>

                  <b-col md="8" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        id="radius"
                        v-model="form.radius"
                        :placeholder="$t('master.form.address.radius')"
                        :disabled="map_radio == 'polygon'"
                        @input="handleSetRadius"
                      >
                        <template #label>
                          <div class="d-flex justify-content-between align-items-center">
                            <label>
                              {{ $t('master.form.address.radius') }}
                              <i class="text-danger">*</i>
                            </label>
                          </div>
                        </template>
                      </FormulateInput>
                    </div>
                  </b-col>

                  <b-col md="4" sm="12">
                    <div class="row mt-4">
                      <span class="mc-form--address__geo">{{
                        $t('setting.list.company.form.geofence')
                      }}</span>
                      <strong v-if="map_radio == 'circle'" class="mc-form--address__geo">{{
                        $t('setting.list.company.form.circle')
                      }}</strong>
                      <strong v-if="map_radio == 'polygon'" class="mc-form--address__geo">{{
                        $t('setting.list.company.form.polygon')
                      }}</strong>
                    </div>
                  </b-col>

                  <b-col v-if="hasAccessAll(['tms:read']) && state == 'customer'" md="12" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.operationalDay"
                        type="choice-chips"
                        :label="$t('master.form.address.operationalDay')"
                        :options="operationalDayOptions"
                        :multiple="true"
                        :all-value="'0'"
                      />
                    </div>
                  </b-col>

                  <b-col v-if="hasAccessAll(['tms:read'])" md="12" sm="12">
                    <div class="mb-3">
                      <b-form-group
                        id="time_label"
                        :label="$t('master.form.customer.operationalTime')"
                        label-for="time"
                        class="p-1"
                      >
                        <div class="row p-0 m-0">
                          <div class="col-md-6 p-0 m-0">
                            <FormulateInput
                              v-model="form.serviceStart"
                              name="service_start"
                              type="date-picker"
                              class="mc-time-start-formulate p-0"
                              format="HH:mm"
                              value-type="format"
                              datepickerType="time"
                              placeholder="HH:mm"
                              icon="icon-outline_clock"
                              validation-behavior="live"
                              error-behavior="live"
                            />
                          </div>
                          <div class="col-md-6 p-0 m-0">
                            <FormulateInput
                              v-model="form.serviceEnd"
                              name="service_end"
                              type="date-picker"
                              class="mc-time-end-formulate p-0"
                              format="HH:mm"
                              value-type="format"
                              datepickerType="time"
                              placeholder="HH:mm"
                              icon="icon-outline_clock"
                              validation-behavior="live"
                              error-behavior="live"
                            />
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>

                  <b-col v-if="state == 'customer'" md="12" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.serviceDuration"
                        name="service_duration"
                        class="__duration-input"
                        :label="$t('master.form.address.serviceDuration')"
                        ignored
                        type="time-duration"
                        :placeholder="$t('master.form.address.serviceDurationPlaceholder')"
                        :optionItems="optionItems"
                      />
                    </div>
                  </b-col>

                  <b-col md="12" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        id="address"
                        name="address_detail"
                        type="textarea"
                        :placeholder="$t('master.form.address.exDetail')"
                        :label="$t('master.form.address.detail')"
                        class="address-form"
                      />
                    </div>
                  </b-col>

                  <FreeWhatsappAlert v-if="!loading" />

                  <h4 class="card-title mb-4 mt-2">
                    {{ $t('setting.list.company.form.contact') }}
                  </h4>
                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.contacts[0].name"
                        :placeholder="$t('master.address.contactName')"
                        :label="$t('master.address.contactName')"
                        class="address-form"
                        :disabled="isGeofenceContactFormFlagActive"
                        :validation="
                          form.contacts[0].sendWhatsapp
                            ? 'required:trim|max:30,length'
                            : 'max:30,length'
                        "
                        :validation-messages="{
                          required: `${$t('master.address.contactName')} ${$t(
                            'global.validation.required'
                          )}`,
                          max: $t('master.form.address.contactLimit'),
                        }"
                        validation-behavior="live"
                        error-behavior="live"
                      />
                    </div>
                  </b-col>

                  <b-col md="6" sm="12">
                    <div class="mb-3">
                      <FormulateInput
                        v-model="form.contacts[0].phoneNo"
                        :placeholder="$t('master.form.employee.phoneNumberPlaceholder')"
                        :label="$t('master.form.employee.phoneNumber')"
                        class="address-form"
                        :disabled="isGeofenceContactFormFlagActive"
                        :validation="
                          form.contacts[0].sendWhatsapp
                            ? 'required:trim|max:15,length'
                            : 'max:15,length'
                        "
                        :validation-messages="{
                          required: `${$t('master.form.employee.phoneNumber')} ${$t(
                            'global.validation.required'
                          )}`,
                          max: $t('setting.list.company.formAlert.phoneLimit'),
                        }"
                        validation-behavior="live"
                        error-behavior="live"
                        @keypress="isPhoneNumber($event)"
                        @paste="isPastePhoneNumber($event)"
                        @change="onChangeNumber()"
                      />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="mb-3 d-flex">
                      <input
                        id="send_whatsapp_checkbox"
                        v-model="form.contacts[0].sendWhatsapp"
                        type="checkbox"
                        :disabled="isGeofenceContactFormFlagActive"
                      />
                      <span class="text-muted ms-1">{{
                        $t('master.form.address.whatsappNotification')
                      }}</span>
                    </div>
                  </b-col>

                  <h4 class="card-title mb-4 mt-2">
                    {{ $t('global.activity') }}
                  </h4>

                  <b-col
                    v-if="hasAccessAll(['tms:read']) && state == 'company'"
                    md="12"
                    sm="12"
                    class="mb-3"
                  >
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_garage"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1 custom-control-input"
                          checked
                          plain
                        >
                          {{ $t('master.form.fleet.garage') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>

                  <b-col
                    v-if="hasAccessAll(['tms:read']) && state == 'company'"
                    md="12"
                    sm="12"
                    class="mb-3"
                  >
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_service"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1"
                          checked
                          plain
                        >
                          {{ $t('setting.list.company.form.locationService') }}
                        </b-form-checkbox>
                      </div>

                      <b-collapse
                        v-model="form.is_service"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-row>
                          <div class="mt-2">
                            <b-form-group
                              id="city_label"
                              label="Tipe Lokasi Servis"
                              label-for="city"
                            >
                              <multiselect
                                v-model="form.service_location"
                                placeholder="Tipe Lokasi Servis"
                                :options="['Internal', 'Eksternal']"
                              />
                            </b-form-group>
                          </div>
                        </b-row>
                      </b-collapse>
                    </div>
                  </b-col>
                  <b-col md="12" sm="12" class="mb-3">
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_depot"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1"
                          checked
                          plain
                        >
                          {{ $t('setting.list.company.form.pickUpAndDeliver') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    v-if="hasAccessAll(['tms:read']) && state == 'customer'"
                    md="12"
                    sm="12"
                    class="mb-3"
                  >
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_billingAddr"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1"
                          checked
                          plain
                        >
                          {{ $t('setting.list.company.form.invoice') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                  <b-col v-if="!hasAccessAll(['tms:read'])" md="12" sm="12" class="mb-3">
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_garage"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1"
                          checked
                          plain
                        >
                          {{ $t('setting.list.company.form.garage') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>

                  <b-col v-if="!hasAccessAll(['tms:read'])" md="12" sm="12" class="mb-3">
                    <div class="p-2 form-control">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="form.is_service"
                          :value="true"
                          :unchecked-value="false"
                          class="mb-1 mt-1"
                          checked
                          plain
                        >
                          {{ $t('setting.list.company.form.locationService') }}
                        </b-form-checkbox>
                      </div>

                      <b-collapse
                        v-model="form.is_service"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-row>
                          <div class="mt-2">
                            <b-form-group
                              id="city_label"
                              label="Tipe Lokasi Servis"
                              label-for="city"
                            >
                              <multiselect
                                v-model="form.service_location"
                                placeholder="Tipe Lokasi Servis"
                                :options="['Internal', 'Eksternal']"
                              />
                            </b-form-group>
                          </div>
                        </b-row>
                      </b-collapse>
                    </div>
                  </b-col>
                </b-skeleton-wrapper>
              </template>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </FormulateForm>

    <!-- Modal for Update Confirmation -->
    <b-modal
      id="modal-change-data"
      class="mc-modal"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
      @ok="toSave"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('master.address.addressAlreadyUse') }}
          <strong>{{ $t('master.form.fleet.garage') }} </strong>
          {{ $t('master.address.byOtherFleet') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton variant="secondary" class="me-2" :text="$t('global.no')" @click="cancel()" />
            <McButton variant="primary" :text="$t('global.yes')" @click="toSave" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
